export default __webpack_public_path__ + "bd19902dd6f6304c6b00729ff16bda76.png";